var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThumbnail2A(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 225,
    viewBox: "0 0 328 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M328 0H0V225H328V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5832 29.6128H8.60645V36.5343H96.5832V29.6128Z",
    stroke: "#CCCCCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5832 84.9844H8.60645V91.9059H96.5832V84.9844Z",
    stroke: "#CCCCCC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5832 140.351H8.60645V147.272H96.5832V140.351Z",
    stroke: "#CCCCCC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5832 57.2993H8.60645V64.2208H96.5832V57.2993Z",
    stroke: "#CCCCCC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5832 112.672H8.60645V119.594H96.5832V112.672Z",
    stroke: "#CCCCCC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5832 168.045H8.60645V174.967H96.5832V168.045Z",
    stroke: "#CCCCCC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5832 43.4546H8.60645V50.376H96.5832V43.4546Z",
    stroke: "#CCCCCC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5832 98.8252H8.60645V105.747H96.5832V98.8252Z",
    stroke: "#CCCCCC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5832 154.2H8.60645V161.122H96.5832V154.2Z",
    stroke: "#CCCCCC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5832 71.1401H8.60645V78.0616H96.5832V71.1401Z",
    stroke: "#CCCCCC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5832 126.515H8.60645V133.436H96.5832V126.515Z",
    stroke: "#CCCCCC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5832 181.886H8.60645V188.808H96.5832V181.886Z",
    stroke: "#CCCCCC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5832 195.727H8.60645V202.648H96.5832V195.727Z",
    stroke: "#CCCCCC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5832 36.5342H8.60645V43.4556H96.5832V36.5342Z",
    stroke: "#CCCCCC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5832 91.9058H8.60645V98.8273H96.5832V91.9058Z",
    stroke: "#CCCCCC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5832 147.276H8.60645V154.198H96.5832V147.276Z",
    stroke: "#CCCCCC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5832 64.2207H8.60645V71.1421H96.5832V64.2207Z",
    stroke: "#CCCCCC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5832 119.589H8.60645V126.511H96.5832V119.589Z",
    stroke: "#CCCCCC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5832 174.967H8.60645V181.888H96.5832V174.967Z",
    stroke: "#CCCCCC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5832 50.376H8.60645V57.2975H96.5832V50.376Z",
    stroke: "#CCCCCC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5832 105.749H8.60645V112.67H96.5832V105.749Z",
    stroke: "#CCCCCC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5832 161.12H8.60645V168.042H96.5832V161.12Z",
    stroke: "#CCCCCC"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5832 78.0654H8.60645V84.9868H96.5832V78.0654Z",
    stroke: "#CCCCCC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5832 133.436H8.60645V140.358H96.5832V133.436Z",
    stroke: "#CCCCCC"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5832 188.803H8.60645V195.724H96.5832V188.803Z",
    stroke: "#CCCCCC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5832 202.644H8.60645V209.565H96.5832V202.644Z",
    stroke: "#CCCCCC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5832 209.572H8.60645V216.493H96.5832V209.572Z",
    stroke: "#CCCCCC"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M148.222 29.6128H96.583V36.5343H148.222V29.6128Z",
    stroke: "#CCCCCC"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M148.222 84.9844H96.583V91.9059H148.222V84.9844Z",
    stroke: "#CCCCCC"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M148.222 140.351H96.583V147.272H148.222V140.351Z",
    stroke: "#CCCCCC"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M148.222 57.2993H96.583V64.2208H148.222V57.2993Z",
    stroke: "#CCCCCC"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M148.222 112.672H96.583V119.594H148.222V112.672Z",
    stroke: "#CCCCCC"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M148.222 168.045H96.583V174.967H148.222V168.045Z",
    stroke: "#CCCCCC"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M148.222 43.4546H96.583V50.376H148.222V43.4546Z",
    stroke: "#CCCCCC"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M148.222 98.8252H96.583V105.747H148.222V98.8252Z",
    stroke: "#CCCCCC"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M148.222 154.2H96.583V161.122H148.222V154.2Z",
    stroke: "#CCCCCC"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M148.222 71.1401H96.583V78.0616H148.222V71.1401Z",
    stroke: "#CCCCCC"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M148.222 126.515H96.583V133.436H148.222V126.515Z",
    stroke: "#CCCCCC"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M148.222 181.886H96.583V188.808H148.222V181.886Z",
    stroke: "#CCCCCC"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M148.222 195.727H96.583V202.648H148.222V195.727Z",
    stroke: "#CCCCCC"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M148.222 36.5342H96.583V43.4556H148.222V36.5342Z",
    stroke: "#CCCCCC"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M148.222 91.9058H96.583V98.8273H148.222V91.9058Z",
    stroke: "#CCCCCC"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M148.222 147.276H96.583V154.198H148.222V147.276Z",
    stroke: "#CCCCCC"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M148.222 64.2207H96.583V71.1421H148.222V64.2207Z",
    stroke: "#CCCCCC"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M148.222 119.589H96.583V126.511H148.222V119.589Z",
    stroke: "#CCCCCC"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M148.222 174.967H96.583V181.888H148.222V174.967Z",
    stroke: "#CCCCCC"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M148.222 50.376H96.583V57.2975H148.222V50.376Z",
    stroke: "#CCCCCC"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M148.222 105.749H96.583V112.67H148.222V105.749Z",
    stroke: "#CCCCCC"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M148.222 161.12H96.583V168.042H148.222V161.12Z",
    stroke: "#CCCCCC"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M148.222 78.0654H96.583V84.9868H148.222V78.0654Z",
    stroke: "#CCCCCC"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M148.222 133.436H96.583V140.358H148.222V133.436Z",
    stroke: "#CCCCCC"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M148.222 188.803H96.583V195.724H148.222V188.803Z",
    stroke: "#CCCCCC"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M148.222 202.644H96.583V209.565H148.222V202.644Z",
    stroke: "#CCCCCC"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M148.222 209.572H96.583V216.493H148.222V209.572Z",
    stroke: "#CCCCCC"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5832 22.6895H8.60645V29.6109H96.5832V22.6895Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M148.222 22.6895H96.583V29.6109H148.222V22.6895Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 29.6128H233.33V36.5343H319.394V29.6128Z",
    stroke: "#CCCCCC"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 84.9844H233.33V91.9059H319.394V84.9844Z",
    stroke: "#CCCCCC"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 140.351H233.33V147.272H319.394V140.351Z",
    stroke: "#CCCCCC"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 57.2993H233.33V64.2208H319.394V57.2993Z",
    stroke: "#CCCCCC"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 112.672H233.33V119.594H319.394V112.672Z",
    stroke: "#CCCCCC"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 168.045H233.33V174.967H319.394V168.045Z",
    stroke: "#CCCCCC"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 43.4546H233.33V50.376H319.394V43.4546Z",
    stroke: "#CCCCCC"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 98.8252H233.33V105.747H319.394V98.8252Z",
    stroke: "#CCCCCC"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 154.2H233.33V161.122H319.394V154.2Z",
    stroke: "#CCCCCC"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 71.1401H233.33V78.0616H319.394V71.1401Z",
    stroke: "#CCCCCC"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 126.515H233.33V133.436H319.394V126.515Z",
    stroke: "#CCCCCC"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 181.886H233.33V188.808H319.394V181.886Z",
    stroke: "#CCCCCC"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 195.727H233.33V202.648H319.394V195.727Z",
    stroke: "#CCCCCC"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 36.5342H233.33V43.4556H319.394V36.5342Z",
    stroke: "#CCCCCC"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 91.9058H233.33V98.8273H319.394V91.9058Z",
    stroke: "#CCCCCC"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 147.276H233.33V154.198H319.394V147.276Z",
    stroke: "#CCCCCC"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 64.2207H233.33V71.1421H319.394V64.2207Z",
    stroke: "#CCCCCC"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 119.589H233.33V126.511H319.394V119.589Z",
    stroke: "#CCCCCC"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 174.967H233.33V181.888H319.394V174.967Z",
    stroke: "#CCCCCC"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 50.376H233.33V57.2975H319.394V50.376Z",
    stroke: "#CCCCCC"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 105.749H233.33V112.67H319.394V105.749Z",
    stroke: "#CCCCCC"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 161.12H233.33V168.042H319.394V161.12Z",
    stroke: "#CCCCCC"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 78.0654H233.33V84.9868H319.394V78.0654Z",
    stroke: "#CCCCCC"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 133.436H233.33V140.358H319.394V133.436Z",
    stroke: "#CCCCCC"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 188.803H233.33V195.724H319.394V188.803Z",
    stroke: "#CCCCCC"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 202.644H233.33V209.565H319.394V202.644Z",
    stroke: "#CCCCCC"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 209.572H233.33V216.493H319.394V209.572Z",
    stroke: "#CCCCCC"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M233.33 29.6128H148.222V36.5343H233.33V29.6128Z",
    stroke: "#CCCCCC"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M233.33 84.9844H148.222V91.9059H233.33V84.9844Z",
    stroke: "#CCCCCC"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M233.33 140.351H148.222V147.272H233.33V140.351Z",
    stroke: "#CCCCCC"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M233.33 57.2993H148.222V64.2208H233.33V57.2993Z",
    stroke: "#CCCCCC"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M233.33 112.672H148.222V119.594H233.33V112.672Z",
    stroke: "#CCCCCC"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M233.33 168.045H148.222V174.967H233.33V168.045Z",
    stroke: "#CCCCCC"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M233.33 43.4546H148.222V50.376H233.33V43.4546Z",
    stroke: "#CCCCCC"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M233.33 98.8252H148.222V105.747H233.33V98.8252Z",
    stroke: "#CCCCCC"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M233.33 154.2H148.222V161.122H233.33V154.2Z",
    stroke: "#CCCCCC"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M233.33 71.1401H148.222V78.0616H233.33V71.1401Z",
    stroke: "#CCCCCC"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M233.33 126.515H148.222V133.436H233.33V126.515Z",
    stroke: "#CCCCCC"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M233.33 181.886H148.222V188.808H233.33V181.886Z",
    stroke: "#CCCCCC"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M233.33 195.727H148.222V202.648H233.33V195.727Z",
    stroke: "#CCCCCC"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M233.33 36.5342H148.222V43.4556H233.33V36.5342Z",
    stroke: "#CCCCCC"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M233.33 91.9058H148.222V98.8273H233.33V91.9058Z",
    stroke: "#CCCCCC"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M233.33 147.276H148.222V154.198H233.33V147.276Z",
    stroke: "#CCCCCC"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M233.33 64.2207H148.222V71.1421H233.33V64.2207Z",
    stroke: "#CCCCCC"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M233.33 119.589H148.222V126.511H233.33V119.589Z",
    stroke: "#CCCCCC"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M233.33 174.967H148.222V181.888H233.33V174.967Z",
    stroke: "#CCCCCC"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M233.33 50.376H148.222V57.2975H233.33V50.376Z",
    stroke: "#CCCCCC"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M233.33 105.749H148.222V112.67H233.33V105.749Z",
    stroke: "#CCCCCC"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M233.33 161.12H148.222V168.042H233.33V161.12Z",
    stroke: "#CCCCCC"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M233.33 78.0654H148.222V84.9868H233.33V78.0654Z",
    stroke: "#CCCCCC"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M233.33 133.436H148.222V140.358H233.33V133.436Z",
    stroke: "#CCCCCC"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M233.33 188.803H148.222V195.724H233.33V188.803Z",
    stroke: "#CCCCCC"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M233.33 202.644H148.222V209.565H233.33V202.644Z",
    stroke: "#CCCCCC"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M233.33 209.572H148.222V216.493H233.33V209.572Z",
    stroke: "#CCCCCC"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 22.6895H233.33V29.6109H319.394V22.6895Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M233.33 22.6895H148.222V29.6109H233.33V22.6895Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1078 8.50928H8.60645V13.2362H85.1078V8.50928Z",
    fill: "#E0E0E0"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M319.393 8.50928H89.8887V13.2362H319.393V8.50928Z",
    fill: "#E0E0E0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnail2A);
export default __webpack_public_path__ + "static/media/thumbnail-2-a.d075b0cf7ff80ee14fb5fd6edcd4776f.svg";
export { ForwardRef as ReactComponent };